export const FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_SUCCESS =
  "FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_SUCCESS";
export const FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_FAILED =
  "FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_FAILED";
export const FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_LOADING =
  "FETCH_STATUS_WISE_CYPRESS_GROUPED_DATA_LOADING";
export const CLEAR_STATUS_WISE_CYPRESS_GROUPED_DATA =
  "CLEAR_STATUS_WISE_CYPRESS_GROUPED_DATA";
export const FETCH_CYPRESS_GROUPED_DATA_LOADING =
  "FETCH_CYPRESS_GROUPED_DATA_LOADING";
export const FETCH_CYPRESS_GROUPED_DATA_SUCCESS =
  "FETCH_CYPRESS_GROUPED_DATA_SUCCESS";
export const FETCH_CYPRESS_GROUPED_DATA_FAILED =
  "FETCH_CYPRESS_GROUPED_DATA_FAILED";
export const SET_ACTIVE_ACCORDION_ON_TEST_LIST =
  "SET_ACTIVE_ACCORDION_ON_TEST_LIST";
export const UPDATE_CYPRESS_GROUPED_DATA = "UPDATE_CYPRESS_GROUPED_DATA";
export const UPDATE_CYP_SIDEBAR_GROUPED_DATA =
  "UPDATE_CYP_SIDEBAR_GROUPED_DATA";
export const CLEAR_CYPRESS_GROUPED_DATA = "CLEAR_CYPRESS_GROUPED_DATA";
export const DELETE_CYPRESS_GROUPED_TEST = "DELETE_CYPRESS_GROUPED_TEST";
